import { tabsProp } from "../interfaces/chart.interface";

export const tabsArr: tabsProp[] = [
  {
    id: "daily",
    title: "Daily",
    data: {
      amount: 3,
      percentage: 12,
    },
  },
  {
    id: "weekly",
    title: "Weekly",
    data: {
      amount: 13,
      percentage: 22,
    },
  },
  {
    id: "monthly",
    title: "Monthly",
    data: {
      amount: 21,
      percentage: 8,
    },
  },
  {
    id: "yearly",
    title: "Yearly",
    data: {
      amount: 123,
      percentage: 18,
    },
  },
];

export const clubStakingColumns = [
  {
    id: "name",
    label: "Name",
    minWidth: 100,
  },
  {
    id: "rasiedAmount",
    label: "Amount",
    minWidth: 170,
  },
  {
    id: "stakingStatus",
    label: "Status",
    minWidth: 170,
  },
];
export const bestTradingTableColumnNames = [
  "NFT name",
  "NFT image",
  "Price",
  "Mint address",
];

export const activeStakingsTableColumnNames = ["Count", "Period"];
export default {};
